export const SvgArrowLeft = () => {
  return (
    <svg
      width="12"
      height="18"
      viewBox="0 0 12 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.82619 17.878C7.997 18.0192 8.26793 18.0411 8.46524 17.9267C8.96883 17.6297 9.44591 17.3035 9.89354 16.9505C10.2469 16.6779 10.5797 16.3882 10.8948 16.079C11.2217 15.765 11.5221 15.4339 11.8019 15.0882C11.9344 14.9251 11.902 14.7085 11.7341 14.5697L5.96498 9.80085C5.47907 9.39675 5.47907 8.74435 5.96498 8.34025L11.8519 3.47401C12.0168 3.33769 12.0492 3.12103 11.9226 2.96036C11.6458 2.60982 11.3483 2.27388 11.0244 1.95255C10.6239 1.54845 10.188 1.16869 9.71684 0.815712C9.37228 0.552804 9.01006 0.306936 8.63311 0.078108C8.43579 -0.0411745 8.16191 -0.0217016 7.98816 0.121924L4.2098 3.24275L2.00109 5.0685C-0.667031 7.27644 -0.667031 10.8647 2.00109 13.0726L7.81736 17.8804L7.82619 17.878Z"
        fill="#3484F7"
      />
    </svg>
  );
};
